<template>
  <router-view></router-view>
</template>

<script>
  export default {
      name: 'OrderTypeLayout'
  }
</script>
